export default __webpack_public_path__ + "static/media/Website Banner 1400 x 600 px Brosur Sept 2022.ae228085.jpg";